// extracted by css-extract-rspack-plugin
export default {"important":"_146c4d8f","trigger":"_8c0e7dd1","expandable":"_7a35cea5"};